import { createEventTracker } from '../util';
import {
  FunnelOrientationAnalytics,
  FunnelVisualizationLegendAnalytics,
  FunnelViewedAnalytics,
  FunnelSavedAnalytics,
  FunnelExploredAnalytics,
  FunnelActionsAnalytics,
  FunnelAddToDashboardAnalytics,
} from './types';

export const trackCreateFunnelSucceeded =
  createEventTracker<FunnelSavedAnalytics>('Create Funnel Succeeded');
export const trackUpdateFunnelSucceeded =
  createEventTracker<FunnelSavedAnalytics>('Update Funnel Succeeded');
export const trackDeleteFunnelSucceeded =
  createEventTracker<FunnelSavedAnalytics>('Delete Funnel Succeeded');
export const trackChangeFunnelOrientation = createEventTracker<FunnelOrientationAnalytics>(
  'Change Funnel Orientation',
);
export const trackClickFunnelVisualizationLegend =
  createEventTracker<FunnelVisualizationLegendAnalytics>('Click Funnel Visualization Legend');
export const trackFunnelViewed = createEventTracker<FunnelViewedAnalytics>('Funnel Viewed');
export const trackFunnelExplored = createEventTracker<FunnelExploredAnalytics>('Funnel Explored');
export const trackFunnelDirtied = createEventTracker<FunnelActionsAnalytics>('Funnel Dirtied');
export const trackFunnelAddToDashboard =
  createEventTracker<FunnelAddToDashboardAnalytics>('Funnel Add To Dashboard');
